import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/LoadingModal/types';
import apiCommonService from 'bff/services/commonService';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { CodeId } from 'constants/enums/codeId.enum';

const LoadingModal: React.FC<IProps> = (props) => {
  /** 保發關貿保期 API 提示訊息 */
  const [policyperiodCode, setPolicyperiodCode] = useState('');

  useEffect(() => {
    async function fetchPolicyperiodCode () {
      const codes = await apiCommonService.fetchCodeTables(CodeClass.UI, CodeId.W049);
      if (codes && codes.length > 0) {
        setPolicyperiodCode(codes[0].CODE_VALUE);
      }
    }
    fetchPolicyperiodCode();
  }, []);

  /**
   * @description 取得保發關貿保期 API 顯示文字
   */
  const handleGetPolicyperiodInfo = () => {
    if (!policyperiodCode) return <p className="modal__content__text">Loading...</p>;

    return (
      <div className="modal__content__dealarea">
        <p className="modal__content__dealarea__title">查詢關貿系統中</p>
        <p className="modal__content__dealarea__text">{policyperiodCode}</p>
      </div>
    );
  };

  return (
    <>
      {props.modal.loadingModalState.visible && (
        <div className="loading__modal">
          <Modal
            visible={props.modal.loadingModalState.visible}
            title=""
            cancelButton={false}
            closeIcon={false}
            confirmButton={false}
          >
            <div className={props.modal.loadingModalState.dealing
              ? 'modal__content__img-dealing'
              : 'modal__content__img'}
            />
            {
              props.modal.loadingModalState.dealing
                ? (
                  <div className="modal__content__dealarea">
                    <p className="modal__content__dealarea__title">交易授權中，請等待授權結果.....</p>
                    <p className="modal__content__dealarea__text">請勿執行瀏覽器[停止]或[重新整理]</p>
                    <p className="modal__content__dealarea__text">避免重複授權或失敗</p>
                  </div>
                )
                : props.modal.loadingModalState.policyperiod
                  ? (
                    handleGetPolicyperiodInfo()
                  )
                  : props.modal.loadingModalState.petLoading
                    ? (
                      <div>資料讀取中，請耐心等候</div>
                    )
                    : <p className="modal__content__text">Loading...</p>
            }
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

export default connect(mapStateToProps)(LoadingModal);
